import React from 'react';
import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

const items = [
  { icon: VerifiedUserOutlinedIcon, text: 'Delivery you can audit — clear scope & ownership' },
  { icon: PublicOutlinedIcon, text: 'Nairobi team · Kenya & East Africa' },
  { icon: SupportAgentOutlinedIcon, text: 'Support after go-live, not drop-and-run' },
  { icon: ArticleOutlinedIcon, text: 'Insights & courses — reasons to return' },
];

export default function TrustStrip() {
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'grey.50',
        py: { xs: 2, md: 2.5 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' },
            gap: { xs: 2, md: 3 },
            alignItems: 'flex-start',
          }}
        >
          {items.map(({ icon: Icon, text }) => (
            <Box key={text} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
              <Icon sx={{ fontSize: 22, color: 'primary.main', opacity: 0.85, mt: 0.25, flexShrink: 0 }} />
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  lineHeight: 1.5,
                  fontWeight: 500,
                  fontSize: compact ? '0.8125rem' : '0.875rem',
                }}
              >
                {text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
